import React, { useState, useEffect, useRef } from 'react';
import { Input, message, Result } from 'antd';
import { BiSearch } from 'react-icons/bi';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { CampaignList } from '../../../apis/Influencer/Campaigns/CampaignList';
import { useGlobalState } from '../../../store/state';
import { HiOutlineEmojiSad } from 'react-icons/hi';
import './InfluencerChatsListComponent.styles.scss';
import { Link } from 'react-router-dom';
// import moment from'moment'

// const {Search} = Input;
const InfluencerChatsListComponent = ({ getActiveChat }) => {
  const [user] = useGlobalState('user');
  // const [company] = useGlobalState('company')
  const scrollRef = useRef();
  const [chatSettings, setChatSettings] = useState({
    active: undefined,
  });
  const randomDate = (start, end) =>{
    return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
  };
  const [chatList, setChatList] = useState([
    // {
    //     title:"New Sports Wear",
    //     campId:"60d06e2e1c72a59e0a2e0ef8",
    //     time:randomDate(new Date(2021,1,1), new Date()),
    //     update: Math.floor(Math.random() * 10)
    // },
    // {
    //     title:"Sublime Shades",
    //     campId:"324hg23i4g234k234j2",
    //     time:randomDate(new Date(2021,1,1), new Date()),
    //     update: Math.floor(Math.random() * 10)
    // },
    // {
    //     title:"Margerate Jacks",
    //     campId:"8457h4363hhh23h5h5h4",
    //     time:randomDate(new Date(2021,1,1), new Date()),
    //     update: Math.floor(Math.random() * 10)
    // },
    // {
    //     title:"Puma max x max erasicotincs",
    //     campId:"213123123bhuuu2g3v13",
    //     time:randomDate(new Date(2021,1,1), new Date()),
    //     update: Math.floor(Math.random() * 10)
    // },
    // {
    //     title:"Jackas Jackfruits",
    //     campId:"3489342i34b234342b2",
    //     time:randomDate(new Date(2020,1,1), new Date()),
    //     update: Math.floor(Math.random() * 10)
    // },
    // {
    //     title:"Man Vs Moz and treats",
    //     campId:"213123b21312ygg22112",
    //     time:randomDate(new Date(2021,1,1), new Date()),
    //     update: Math.floor(Math.random() * 10)
    // },
    // {
    //     title:"Jelly jobs Promo",
    //     campId:"sfbsdjfsdfds87f8sdds",
    //     time:randomDate(new Date(2020,1,1), new Date()),
    //     update: Math.floor(Math.random() * 10)
    // }
  ]);
  const [chatListFiltered, setChatListFiltered] = useState(chatList);
  useEffect(()=>{ // load cmapigns to chat
    const _lists = [];
    CampaignList(user.accessToken, { full: 'yes' }).then(({ status, response })=>{
      console.log('val', response);
      if (status === 200) {
        response.campaigns.map((list) =>{
          const _v = {
            campId: list.campaignId,
            title: list.campaignInfo.name,
            // time: randomDate(new Date(2021, 1, 1), new Date()),
            // update: Math.floor(Math.random() * 10)
          };
          _lists.push(_v);
        });
        setChatList([
          ..._lists,
        ]);
        setChatListFiltered([
          ..._lists,
        ]);
      } else {
        message.error('There is some issue while fetching chatlist');
      }
    });
  }, []);

  const searchInLIst = (e) =>{
    const _v = e.target.value.toLowerCase();
    // let _filtered = [];
    const _filtered = chatList.filter((data)=>{
      return _v ? data.title.toLowerCase().match(_v): chatList;
    });
    setChatListFiltered(_filtered);
  };

  const openChat = (i, _obj) =>{
    setChatSettings({
      ...chatSettings,
      active: i,
    });
    // setActiveChat(_obj)
    getActiveChat(_obj);
  };

  // useEffect(() => {
  //     scrollRef.current.scrollToBottom()
  // }, [])

  return (
    <div className="common_card chat_list">
      <div className="chat_list_search p-2">
        <Input size="large"
          allowClear
          onChange={searchInLIst}
          placeholder="Search"
          prefix={<BiSearch color={'#888'}/>}/>
      </div>
      <div className="chat_list_area">
        <Scrollbars
          ref={scrollRef}
          universal
          style={{ maxHeight: '100%', height: '100%' }}>
          {
            chatListFiltered.length ? chatListFiltered.map(({ title, campId, time, update }, index)=>(
              <div
                key={campId}
                className={`chat_list_each p-3 ${chatSettings.active === index ? 'active': ''}`}
                onClick={() => openChat(index, { title, campId })}>
                <div className="row">
                  <div className="col-8">
                    <h4 className="chat_list_each--title">{title}</h4>
                    <h6 className="chat_list_each--campid">{campId}</h6>
                  </div>
                  {/* <div className="col text-right">
                                        <h4 className="chat_list_each--time">{moment(time, "YYYYMMDD").endOf('day').fromNow()}</h4>
                                        {
                                            update?
                                            <div className="chat_list_each--badge">New <span>{update}</span></div>
                                            : null
                                        }
                                    </div> */}
                </div>
              </div>
            )) :
              (
                <Result
                  title="No Chat data"
                  // subTitle="There is no chat available"
                  subTitle={
                    chatList.length?
                      'There is no search result in this keyword' :
                      <>There is no campaigns to start chat</>
                  }
                  extras={
                    chatList.length ?
                      null :
                      <Link to={`influencer/campaigns`}
                        className="common_button"></Link>
                  }
                  className="chat_list_empty text-center p-5"/>
            // <HiOutlineEmojiSad size={24} color="#999"/>

              )
          }
        </Scrollbars>
      </div>
    </div>
  );
};

export default InfluencerChatsListComponent;
